import { render, staticRenderFns } from "./AddDict.vue?vue&type=template&id=6be57404&"
import script from "./AddDict.vue?vue&type=script&lang=js&"
export * from "./AddDict.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports